import CryptoJS from 'crypto-js'
import { JSEncrypt } from 'jsencrypt'

/**
 * AESEncoder
 * @param {*} options
 */
const AESEncoder = function ({
  AESKey,
  iv,
  mode = 'CBC',
  pad = 'Pkcs7'
} = {}) {
  if (!AESKey) {
    throw new Error('AESEncoder: please check arguments')
  }
  if (AESKey.length !== 32) {
    throw new Error('AESEncoder: AESKey invalid')
  }!iv &&
    (iv = AESKey.split('')
      .map(c => c.charCodeAt())
      .join('')
      .slice(0, 16))
  this.key = CryptoJS.enc.Utf8.parse(AESKey)
  this.iv = CryptoJS.enc.Utf8.parse(iv)
  this.mode = CryptoJS.mode[mode]
  this.padding = CryptoJS.pad[pad]
}
AESEncoder.prototype.encrypt = function (text) {
  return CryptoJS.AES.encrypt(text, this.key, {
    iv: this.iv,
    mode: this.mode,
    padding: this.padding
  }).toString()
}
AESEncoder.prototype.decrypt = function (text) {
  return CryptoJS.AES.decrypt(text, this.key, {
    iv: this.iv,
    mode: this.mode,
    padding: this.padding
  }).toString(CryptoJS.enc.Utf8)
}

/**
 * RSAEncoder
 * @param {*} RSAKey
 * @param {*} isPubKey
 */
const RSAEncoder = function (RSAKey, isPubKey = true) {
  if (!RSAKey) {
    throw new Error('RSAEncoder: please check arguments')
  }
  this.JSEncrypt = new JSEncrypt()
  this.isPubKey = isPubKey
  isPubKey
    ? this.JSEncrypt.setPublicKey(RSAKey)
    : this.JSEncrypt.setPrivateKey(RSAKey)
}
RSAEncoder.prototype.encrypt = function (text) {
  return this.isPubKey && this.JSEncrypt.encrypt(text)
}
RSAEncoder.prototype.decrypt = function (text) {
  return !this.isPubKey && this.JSEncrypt.decrypt(text).toString('utf8')
}
RSAEncoder.prototype.sign = function (text) {
  return !this.isPubKey && this.JSEncrypt.sign(text, CryptoJS.SHA256, 'sha256')
}
RSAEncoder.prototype.verify = function (text, sign) {
  return this.isPubKey && this.JSEncrypt.verify(text, sign, CryptoJS.SHA256)
}

/**
 * JSFCrypto
 * @param {*} rsaPubKey
 */
const JSFCrypto = function (rsaPubKey) {
  if (!rsaPubKey) {
    throw new Error('JSFCrypto: please check arguments')
  }
  this.RSAEncoder = new RSAEncoder(rsaPubKey)
  this.AESKey = null
  this.AESEncoder = null
}
JSFCrypto.generateRandomKey = function (length = 32) {
  let str = ''
  let pos = 0

  const arr = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ]
  for (let i = 0; i < length; i += 1) {
    pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
JSFCrypto.prototype.setAESKey = function (key) {
  // token
  this.AESKey = key || JSFCrypto.generateRandomKey() // !!token ? CryptoJS.SHA256(token).toString().slice(0, 32) :
  this.AESEncoder = new AESEncoder({
    AESKey: this.AESKey
  })
}
JSFCrypto.prototype.encrypt = function (params, aesKey) {
  try {
    this.setAESKey(aesKey)
    return {
      key: this.RSAEncoder.encrypt(this.AESKey),
      data: this.AESEncoder.encrypt(JSON.stringify(params))
    }
  } catch (e) {
    console.error(e)
    return params
  }
}
JSFCrypto.prototype.decrypt = function (response) {
  try {
    // const {
    //   sign,
    //   data
    // } = JSON.parse(response)
    const {
      sign,
      data
    } = response
    if (!!sign && !!data && this.RSAEncoder.verify(this.AESKey, sign)) {
      return this.AESEncoder.decrypt(data)
    }
    throw new Error(`返回结果错误：${response}`)
  } catch (e) {
    console.error(e)
    return JSON.stringify({
      status: {
        code: 9999,
        message: '返回结果验签失败'
      },
      data: ''
    })
  }
}
/* JSFCrypto.prototype.getSignature = function (params, token) {
  try {
    if (!!token) {
      !params && (params = {});
      let text = Object.keys(params).map(key => params[key]).sort().join(''); // .concat(token)
      this.setAESKey(token);
      params._signature = this.RSAEncoder.encrypt(CryptoJS.SHA256(text).toString());
    }
    return params;
  } catch (e) {
    // console.log(e);
    return params;
  }
}; */
JSFCrypto.prototype.sign = function (params, headers, aesKey) {
  try {
    const signArray = params ? Object.keys(params).map(key => params[key]) : []
    this.setAESKey(aesKey)
    // headers['x-timestamp'] = Date.now();
    headers['x-secret-key'] = this.RSAEncoder.encrypt(this.AESKey)
    headers['x-authentication'] = this.AESEncoder.encrypt(
      CryptoJS.SHA256(
        signArray
          .concat(this.AESKey)
          .sort()
          .join('')
      ).toString()
    )
    return headers
  } catch (e) {
    console.error(e)
    return headers
  }
}

export default { JSFCrypto: JSFCrypto }
